import {mq} from '@miro-site/design-tokens'
import * as React from 'react'
import styled from 'styled-components'
import type {BoxProps} from './Box'
import Box from './Box'

const StyledDiv = styled(Box)<HideProps>`
  ${({theme, $on}) => {
    return Object.keys(theme.mediaQueries).map(
      q =>
        $on.includes(q) &&
        mq[q]({
          display: 'none',
        }),
    )
  }}
`

export interface HideProps extends BoxProps {
  $on: Array<string>
  $block?: boolean
  children: React.ReactNode
}

const Hide = React.forwardRef<HTMLElement, HideProps>(({$on = [], children, ...props}, ref) => {
  return (
    <StyledDiv ref={ref} $on={$on} {...props}>
      {children}
    </StyledDiv>
  )
})

Hide.displayName = 'Hide'

export default Hide
